import React from 'react';
import { NavLink } from 'react-router-dom';

export function Navigation() {
  const linkStyle = ({ isActive }) => ({
    textDecoration: 'none',
    color: isActive ? '#007bff' : '#333',
    fontWeight: isActive ? '700' : '500',
    fontSize: '0.95rem',
    padding: '6px 4px',
    borderBottom: isActive ? '2px solid #007bff' : '2px solid transparent',
    transition: 'all 0.2s ease',
  });

  return (
    <nav
      style={{
        backgroundColor: '#fff',
        borderBottom: '1px solid #e9ecef',
        padding: '12px 20px',
        marginBottom: '20px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '28px',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <NavLink to="/" style={linkStyle} end>
          🏠 Home
        </NavLink>
        <NavLink to="/results" style={linkStyle}>
          📊 Results
        </NavLink>
        <NavLink to="/about" style={linkStyle}>
          ℹ️ About
        </NavLink>
        <NavLink to="/faq" style={linkStyle}>
          ❓ FAQ
        </NavLink>
        <NavLink
          to="/upload"
          style={({ isActive }) => ({
            ...linkStyle({ isActive }),
            backgroundColor: isActive ? '#007bff' : '#28a745',
            color: '#fff',
            padding: '8px 16px',
            borderRadius: '20px',
            borderBottom: 'none',
            fontWeight: '600',
          })}
        >
          📸 Add My Photo
        </NavLink>
      </div>
    </nav>
  );
}
